import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { getLaenderCodes } from "../constants"
import { EventBus } from "../eventbus"
import { useStoreRechnung } from "../store"

interface LieferinformationViewProps {
    basePath: string
}

export function LieferinformationView({ basePath }: LieferinformationViewProps) {
    const laenderOptions = getLaenderCodes()
    const { t } = useTranslation()
    const { lieferinformation } = useStoreRechnung("lieferinformation")
    const onChange = useCallback<(path: string) => (value: unknown) => void>(
        (path) => (value) => {
            EventBus.instance.emit("changeProperty", `${basePath}.${path}`, value)
        },
        [basePath],
    )

    return (
        <Components.Collapsible title={t("rechnung.lieferinformation.title")} collapsed={true}>
            <Components.FormGroup label={t("rechnung.lieferinformation.name.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.lieferinformation.name.placeholder")}
                    onChange={onChange("name")}
                    value={lieferinformation.name}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.lieferinformation.kennung.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.lieferinformation.kennung.placeholder")}
                    onChange={onChange("kennung")}
                    value={lieferinformation.kennung}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.lieferinformation.lieferadresse.strasse1.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.lieferinformation.lieferadresse.strasse1.placeholder")}
                    onChange={onChange("lieferadresse.strasse1")}
                    value={lieferinformation.lieferadresse?.strasse1}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.lieferinformation.lieferadresse.strasse2.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.lieferinformation.lieferadresse.strasse2.placeholder")}
                    onChange={onChange("lieferadresse.strasse2")}
                    value={lieferinformation.lieferadresse?.strasse2}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.lieferinformation.lieferadresse.strasse3.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.lieferinformation.lieferadresse.strasse3.placeholder")}
                    onChange={onChange("lieferadresse.strasse3")}
                    value={lieferinformation.lieferadresse?.strasse3}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.lieferinformation.lieferadresse.ort.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.lieferinformation.lieferadresse.ort.placeholder")}
                    onChange={onChange("lieferadresse.ort")}
                    value={lieferinformation.lieferadresse?.ort}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.lieferinformation.lieferadresse.plz.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.lieferinformation.lieferadresse.plz.placeholder")}
                    onChange={onChange("lieferadresse.plz")}
                    value={lieferinformation.lieferadresse?.plz}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.lieferinformation.lieferadresse.land.label")}>
                <Components.MultiSelect
                    placeholder={t("rechnung.lieferinformation.lieferadresse.land.placeholder")}
                    onChange={onChange("lieferadresse.land")}
                    value={laenderOptions.find((o) => o.value === lieferinformation.lieferadresse?.land)}
                    options={laenderOptions}
                />
            </Components.FormGroup>
        </Components.Collapsible>
    )
}
